/** A note that the Datasets page saved for the user starts with a `<dataset_note kind="…" />` tag. */
const DATASET_NOTE_TAG = /^\s*<dataset_note\s+[^>]*?kind="([^"]*)"[^>]*\/>/;

/** The kind of a note, such as cleared_cells, and the text after its tag. */
export const parseDatasetNote = (raw: string): { note: string | null; rest: string } => {
  const match = raw.match(DATASET_NOTE_TAG);
  return match ? { note: match[1], rest: raw.slice(match[0].length) } : { note: null, rest: raw };
};

/** A note tells the agent about a change on the page. The user did not write it, and no reply follows it. */
export const isDatasetNote = (content: string | undefined) =>
  Boolean(content && DATASET_NOTE_TAG.test(content));

/**
 * The first line of a note, for the chat. It drops the column IDs, which are
 * for the agent, and the colon before the list of the other lines.
 */
export const noteSummary = (line: string) =>
  line
    .replace(/\s*\(column_id [^)]*\)/g, "")
    .replace(/,\s*column_id [^,)]*/g, "")
    .replace(/:\s*$/, ".");
